<template>
	<el-autocomplete
		:value="value"
		:fetch-suggestions="querySearchCityAsync"
		clearable
		value-key="name"
		@select="handleSelect"
		@input="handleInput">
		<template slot-scope="{ item }">
			<div>{{ item.name }} / {{ item.county }} / {{ item.iczuj }}</div>
		</template>
	</el-autocomplete>
</template>

<script>
import { Autocomplete as ElAutocomplete } from 'element-ui';

export default {
	name: 'DefinedCityAutocomplete',

	components: {
		ElAutocomplete,
	},

	props: {
		value: {
			type: String,
			default: '',
		},
	},

	methods: {
		async querySearchCityAsync(queryString, cb) {
			if (!queryString || queryString.length < 1) {
				cb([]);
				return;
			}
			try {
				const cities = await this.$service.city.searchByName(queryString);
				cb(cities);
			} catch {
				cb([]);
			}
		},
		handleSelect(val) {
			this.$emit('select', val);
		},
		handleInput(val) {
			this.$emit('input', val);
		},
	},
};
</script>
